import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ServicesMenuItem = ({ styles, serviceName, onClick }) => {
    return (
        <h4 className={styles.container}>
            <button onClick={onClick} type="button" className={styles.button}>
                <FormattedMessage id={serviceName} />
            </button>
        </h4>
    );
};

ServicesMenuItem.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
        button: PropTypes.string.isRequired,
    }).isRequired,
    serviceName: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ServicesMenuItem;
